import { unwrap } from 'api/schema/utils';
import env from 'utils/env';
export default function parseFiles(data) {
    const files = unwrap(data === null || data === void 0 ? void 0 : data.files) || [];
    return files.map((node) => (Object.assign(Object.assign({}, node), { file: (node === null || node === void 0 ? void 0 : node.file) ? `${env.static}/${node.file}` : null })));
}
